import { useMemo } from 'react';
import { pathOr, stringToPath } from 'remeda';
import { useConversationMessageDraft } from 'src/graphql';
import { useNotificationCount } from 'src/graphql/entities/notification/hooks/use-notification-count';
import { REPORTS_NAVIGATION } from 'src/pages/Reports';
import { BASE_WORKSPACE_MENU_ITEMS, CRM_REPLACEMENT_MENU_ITEMS } from './constants';
import { NavigationDataItem } from './use-navigation-items';

export const useWorkspaceMenuItems = () => {
  const { unreadCount } = useNotificationCount();
  const { visibleDrafts } = useConversationMessageDraft();
  const draftsCount = visibleDrafts.length;

  return useMemo(() => {
    const data = { unreadCount, draftsCount };

    const items = [
      ...BASE_WORKSPACE_MENU_ITEMS,
      ...CRM_REPLACEMENT_MENU_ITEMS,
      ...REPORTS_NAVIGATION,
    ] as NavigationDataItem[];

    return items
      .map((i) => {
        if (!i.badgeDataPath) {
          return i;
        }

        const badgeDataContent = pathOr(
          data,
          stringToPath(i.badgeDataPath as keyof typeof data),
          0,
        );

        if (!badgeDataContent) {
          return i;
        }

        return {
          ...i,
          badgeContent: String(badgeDataContent),
        };
      })
      .filter((i) => !i.hideWithNoCount || i.badgeContent);
  }, [draftsCount, unreadCount]);
};
